import { render } from "./UserForm.vue?vue&type=template&id=6ce2a17d"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__